import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Curtains/banner-curtain.jpg';
import CircularGallery from './CircularBagGallery';
import "./Services.css";

function Bags() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>CURTAINS</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Sustainability meets sophistication in our handcrafted curtain collections. Thoughtfully created using eco-friendly, recycled, upcycled, and organic materials, our vendors offer an exceptional range of options that honor both style and sustainability. Choose from exquisite fabrics such as linen, cotton, hemp, jute, and PET yarn — each woven to bring natural elegance and refined texture to any space.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>
        </>
    )
}

export default Bags